import { ApiProperty } from '@nestjs/swagger';
import { IsStrongPassword } from '../decorators/is-strong-password';

export class AuthUpdatePasswordDto {
  @ApiProperty()
  @IsStrongPassword()
  password!: string;
}
